import { PageHeader } from "@shared/components/PageHeader";
import { Mail, MessageSquare } from "lucide-react";
import React from "react";
import TextMessageDashboard from "../dashboard/dashboard";
import TextMessageList from "../list/list";

const TextMessageLanding = () => {
  return (
    <div>
      <div className="flex items-center gap-4">
        <MessageSquare className="w-5 h-5 text-black" />
        <PageHeader
          title="Text Message Statistics"
          subtitle="Overview of text message performance"
        />
      </div>
      <div className="mt-4">
        <TextMessageDashboard />
      </div>
      <div className="mt-4">
        <TextMessageList />
      </div>
    </div>
  );
};

export default TextMessageLanding;
